$(document).on("input", "input#place_website", function (e) {
  $(this).val(window.normalizeUrl(e.target.value))
})
